export default {
    Ready : "ready",
    Loading : "loading",
    Error : "error"
}
